<div>
    <div class="title">Filters</div>

    <div class="container-from-to" *ngIf="isAcqnOption || isLenderRankingOption">
        <div class="container-half">
            <div class="label">From</div>
            <fm-select [options]="selectStartPeriod" [(ngModel)]="acqnFiltersDetails.startPeriod"
                (onChange)="setEndPeriodDates()" placeholder=""></fm-select>
        </div>

        <div class="container-half">
            <div class="label">To</div>
            <fm-select [options]="selectEndPeriod" [(ngModel)]="acqnFiltersDetails.endPeriod"
                (onChange)="onShowSelectionChange()" placeholder=""></fm-select>
        </div>
    </div>

    <div *ngIf="acqnFiltersDetails.isInternal && (isAcqnOption || isDataFileOption)">
        <div class="label">Lender</div>
        <fm-select [options]="acqnFiltersDetails.lenderList" [(ngModel)]="acqnFiltersDetails.lender"
            (onChange)="onShowSelectionChange()" placeholder=""></fm-select>
    </div>

    <div *ngIf="isAcqnOption">
        <div class="label">Acquisition Status</div>
        <fm-select [options]="acqnFiltersDetails.acquisitionStatusList" [(ngModel)]="acqnFiltersDetails.acquisitionStatus"
            (onChange)="onShowSelectionChange()" placeholder=""></fm-select>
    </div>

    <div *ngIf="isAcqnOption">
        <div class="label">Supplemental</div>
        <fm-select ariaLabelledBy="disable" [options]="acqnFiltersDetails.supplementalList" [(ngModel)]="acqnFiltersDetails.supplemental"
            (onChange)="onShowSelectionChange()" defaultLabel="" [filter]="false"></fm-select>
    </div>

    <div *ngIf="isAcqnOption">
        <div class="label">Loan Refinance Type</div>
        <fm-select ariaLabelledBy="disable" [options]="acqnFiltersDetails.loanRefinanceTypeList" [(ngModel)]="acqnFiltersDetails.loanRefinanceType"
            (onChange)="onShowSelectionChange()" defaultLabel="" [filter]="false"></fm-select>
    </div>
    
    <div *ngIf="isAcqnOption">
        <div class="label">Small Loan Balance</div>
        <fm-select ariaLabelledBy="disable" [options]="acqnFiltersDetails.smallLoanBalanceList" [(ngModel)]="acqnFiltersDetails.smallLoanBalance"
            (onChange)="onShowSelectionChange()" defaultLabel="" [filter]="false"></fm-select>
    </div>
    
    <div *ngIf="isAcqnOption">
        <div class="label">Transaction Type</div>
        <fm-select ariaLabelledBy="disable" [options]="acqnFiltersDetails.transactionTypeList" [(ngModel)]="acqnFiltersDetails.transactionType"
        (onChange)="onShowSelectionChange()" defaultLabel="" [filter]="false"></fm-select>
    </div>

    <button class="top-button" fmButton type="button" [large]="true" [primary]="true" label="Apply Filters" (click)="onClickApplyFilters()"></button>
    <button class="center-button" fmButton type="button" [large]="true" label="Reset Filters" (click)="onClickResetFilters()"></button>
    <button class="center-button" fmButton type="button" [large]="true" label="Cancel" (click)="onClickCloseSidebar()"></button>
</div>